import styled from '@emotion/styled';

const Third:React.FC<any> = () => {
  return (
    <Container>
      <BodyImgContainer>
        <Img src="/images/newLanding/landingApp/368722017.png"/>
      </BodyImgContainer>
      <TextContainer>
        <Text1>
          <span>더 많이 뽑고 싶으면,&nbsp; </span> 얼마든
        </Text1>
        <SmallText>
          많이 뽑는만큼
          <br/>쌓이는 추억은 많아지니까요
        </SmallText>
      </TextContainer>
    </Container>
  )
};

export default Third;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ede3cd;
`;

const BodyImgContainer = styled.div`
  width: 100%;
  margin: 70px auto 40px;
`;

const Img = styled.img`
  width: 100%;
`;


const Text1 = styled.div`
  font-size: 20px;
  display: flex;
  margin: 40px auto 0px;

  span {
    font-weight: 600;
  }
`;

const TextContainer = styled.div`
  width: 100%;
  background-color: #ede3cd;
  display: flex;
  flex-direction: column;
`


const SmallText = styled.div`
  font-size: 14px;
  margin: 30px auto 140px;
  text-align: center;
`